@if (filter) {
    <div class="filter-row">
        <mat-form-field class="filter-field" subscriptSizing="dynamic">
            <mat-label>Filter rows</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput [value]="filterText" (input)="applyFilter($any($event.target).value)" aria-label="Filter rows in table" autocomplete="off">
            @if (filterText) {
                <button mat-icon-button matSuffix (click)="clearFilter()" aria-label="Clear filter" matTooltip="Clear filter">
                    <mat-icon>close</mat-icon>
                </button>
            }
        </mat-form-field>
        <span class="count" aria-live="polite">
            {{filterText ? (shown + ' of ' + total) : total}} {{total === 1 ? 'item' : 'items'}}
        </span>
    </div>
}

<div [style]="getTableStyle()">
    <table mat-table [dataSource]="datasource" matSort>
        @for (column of columns; track column.name) {
            <ng-container matColumnDef="{{column.name}}">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!isSortable(column)" [style]="getAlignment(column, true)"> {{column.header}}</th>
                <td mat-cell *matCellDef="let element" [style]="getAlignment(column, false)">
                    @if (column.type === 'node-svg') {
                        <app-node-svg [settings]="element[column.name]"/>
                    }@else if (column.type === 'image') {
                        <span><img height="20" [src]="element[column.name]" alt=""></span>
                    }@else if (column.type === 'icon') {
                        <span class="material-symbols-outlined" aria-hidden="true">
                            {{element[column.name]}}
                        </span>
                    }@else if (column.type === 'icon-button') {
                        @if (element[column.name]===true) {
                            <button mat-icon-button [color]="column.colour" [matTooltip]="column.tooltip" [attr.aria-label]="column.tooltip || column.header" data-testid="canEdit" (click)="columnClick(element, column);$event.stopPropagation()">
                                <span class="material-symbols-outlined" aria-hidden="true">
                                    {{column.icon}}
                                </span>
                            </button>
                        }
                    }@else if (column.type === 'button') {
                        @if (element[column.name] && element[column.name].length > 0) {
                            <button mat-button [color]="column.colour" [matTooltip]="column.tooltip" (click)="columnClick(element, column);$event.stopPropagation()">
                                {{element[column.name]}}
                            </button>
                        }
                    }@else if (column.type === 'date') {
                        {{element[column.name] | date}}
                    }@else if (column.type === 'datetime') {
                        {{element[column.name] | date:'d/M/yy, h:mm a'}}
                    }@else if (column.type === 'number') {
                        {{element[column.name] | number}}
                    }@else if (column.type === 'currency') {
                        {{element[column.name] | currency: currencyCode: 'symbol-narrow': '1.0-0'}}
                    }@else {
                        {{element[column.name]}}
                    }
                </td>
            </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="columnNames; sticky:true"></tr>
        <tr mat-row *matRowDef="let element; columns: columnNames;"
            [class.selected]="isSelected(element)" [class.row-select]="rowSelect" [style.color]="element.colour"
            [attr.tabindex]="rowSelect ? 0 : null" [attr.aria-selected]="rowSelect ? isSelected(element) : null"
            (click)="selectRow(element); $event.stopPropagation()" (dblclick)="dblClick(element); $event.stopPropagation()"
            (keydown.enter)="selectRow(element)"></tr>
        <tr class="mat-mdc-row no-data" *matNoDataRow>
            <td class="mat-mdc-cell" [attr.colspan]="columnNames.length">
                {{filterText ? 'No rows match "' + filterText + '".' : 'Nothing to show yet.'}}
            </td>
        </tr>
    </table>
</div>
